import { defineMessages } from "react-intl";

export const communicationChannelsWizardMessages = defineMessages({
  wizardTitle: {
    defaultMessage: "Channel Name",
    id: "communicationChannelsWizardMessages.wizardTitle",
  },

  // First step

  channelNameField: {
    defaultMessage: "Name",
    id: "communicationChannelsWizardMessages.channelNameField",
  },

  channelNameDesc: {
    defaultMessage: "Description",
    id: "communicationChannelsWizardMessages.channelNameDesc",
  },

  // Second step

  accessEntra: {
    defaultMessage: "Access to Microsoft Entra ID",
    id: "communicationChannelsWizardMessages.accessEntra",
  },

  accessEntraText: {
    defaultMessage:
      "To configure notifications, admin consent must be granted to Guardian. To do this, click the Grant button below. You will be redirected to the Microsoft sign-in page. Log in as a Global Administrator for the tenant to grant admin consent. {link}.",
    id: "communicationChannelsWizardMessages.accessEntraText",
  },

  accessEntraField: {
    defaultMessage: "Administrative account name",
    id: "communicationChannelsWizardMessages.accessEntraField",
  },

  grant: {
    defaultMessage: "Grant",
    id: "communicationChannelsWizardMessages.grant",
  },

  // third step

  selectUserAccount: {
    defaultMessage: "Select user account",
    id: "communicationChannelsWizardMessages.selectUserAccount",
  },

  selectUserAccountText: {
    defaultMessage:
      "Select user account which will send notifications. To do this, click the Grant button below. You will be redirected to the Microsoft sign-in page. Log in as a user with valid Exchange Online / Microsoft Teams license.",
    id: "communicationChannelsWizardMessages.selectUserAccountText",
  },

  selectUserAccountOptionRecommended: {
    defaultMessage: "Specify user account (recommended)",
    id: "communicationChannelsWizardMessages.selectUserAccountOptionRecommended",
  },

  selectUserAccountOptionNotRecommended: {
    defaultMessage: "User administrative account (not recommended)",
    id: "communicationChannelsWizardMessages.selectUserAccountOptionNotRecommended",
  },

  userAccountField: {
    defaultMessage: "User account name",
    id: "communicationChannelsWizardMessages.userAccountField",
  },

  // fourth step

  configureExchangeOnline: {
    defaultMessage: "Configure Exchange Online",
    id: "communicationChannelsWizardMessages.configureExchangeOnline",
  },

  configureExchangeOnlinePage: {
    defaultMessage: "Configure sender and recipients for Exchange Online",
    id: "communicationChannelsWizardMessages.configureExchangeOnlinePage",
  },

  configureExchangeOnlineField: {
    defaultMessage: "Sender",
    id: "communicationChannelsWizardMessages.configureExchangeOnlineField",
  },

  configureExchangeOnlineRecipients: {
    defaultMessage: "Recipients",
    id: "communicationChannelsWizardMessages.configureExchangeOnlineRecipients",
  },

  configureExchangeOnlineAddRecipients: {
    defaultMessage: "Add recipients",
    id: "communicationChannelsWizardMessages.configureExchangeOnlineAddRecipients",
  },

  //Configure Exchange Online

  test: {
    defaultMessage: "Test",
    id: "communicationChannelsWizardMessages.test",
  },

  LearnMoreAboutAdmin: {
    defaultMessage: "Learn more about admin",
    id: "communicationChannelsWizardMessages.LearnMoreAboutAdmin",
  },

  LearnMore: {
    defaultMessage: "Learn more",
    id: "communicationChannelsWizardMessages.LearnMore",
  },

  summary: {
    defaultMessage: "Summary",
    id: "communicationChannelsWizardMessages.summary",
  },

  adminAccountMissMatch: {
    defaultMessage:
      "The consent is not granted for this account. Please repeat authentication process by pressing Grant button again or use account with already granted consent.",
    id: "communicationChannelsWizardMessages.adminAccountMissMatch",
  },

  userAccountMissMatch: {
    defaultMessage:
      "The consent is not granted for this account. Please repeat authentication process by pressing Grant button again or use account with already granted consent.",
    id: "communicationChannelsWizardMessages.userAccountMissMatch",
  },
});
